import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { APIstatsDashboardOverview } from '../../api/Stats';
import { APIupdateUserSettings } from '../../api/User';

import { formatBytes } from '../../helpers/Files';
import { getUserSetting } from '../../helpers/Settings';

import LoadingSmall from '../LoadingSmall';

const DashboardStatsOverview = ({ profile }) => {
  const [stats, setStats] = useState(null);
  const [statsLoading, setStatsLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [period, setPeriod] = useState(getUserSetting('dashboard_period'));

  const intl = useIntl();

  const updatePeriod = (periodValue) => {
    setSaving(true);
    APIupdateUserSettings(profile.uuid, { dashboard_period: periodValue })
      .then(() => {
        setPeriod(periodValue);
        setSaving(false);
      });
  };

  useEffect(() => {
    if (!period) {
      return;
    }

    setStatsLoading(true);
    APIstatsDashboardOverview({ period }).then((response) => {
      setStats(response.data);
      setStatsLoading(false);
    });
  }, [period]);

  return (
    <div className="dashboard-section widget widget-stats-overview">
      <div className="dashboard-section-title">
        <div>
          <h3>{intl.formatMessage({ defaultMessage: 'Workspace stats' })}</h3>
          <UncontrolledDropdown
            direction="down"
            className="period-select-dropdown"
          >
            <DropdownToggle tag="span" disabled={saving}>
              {period === 'week' && intl.formatMessage({ defaultMessage: 'My Week' })}
              {period === 'month' && intl.formatMessage({ defaultMessage: 'My Month' })}
              <i className="fal fa-chevron-down" />
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem
                onClick={() => { updatePeriod('week'); }}
                active={period === 'week'}
              >
                {intl.formatMessage({ defaultMessage: 'My Week' })}
              </DropdownItem>
              <DropdownItem
                onClick={() => { updatePeriod('month'); }}
                active={period === 'month'}
              >
                {intl.formatMessage({ defaultMessage: 'My Month' })}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </div>
      <div className="dashboard-section-content">
        <div className="widget widget-stat-overview">
          <div className="widget-stat">
            <span>{intl.formatMessage({ defaultMessage: 'New files' })}</span>
            <div className="stats-number">
              {statsLoading ? (
                <LoadingSmall />
              ) : (
                stats.files_new
              )}
            </div>
          </div>
          <div className="widget-stat">
            <span>{intl.formatMessage({ defaultMessage: 'Shared files' })}</span>
            <div className="stats-number">
              {statsLoading ? (
                <LoadingSmall />
              ) : (
                stats.files_shared
              )}
            </div>
          </div>
          <div className="widget-stat">
            <span>{intl.formatMessage({ defaultMessage: 'Downloaded files' })}</span>
            <div className="stats-number">
              {statsLoading ? (
                <LoadingSmall />
              ) : (
                stats.files_downloaded
              )}
            </div>
          </div>
          <div className="widget-stat">
            <div className="widget-stat-header">
              <span>{intl.formatMessage({ defaultMessage: 'Storage usage' })}</span>
            </div>
            <div className="stats-number">
              {statsLoading ? (
                <LoadingSmall />
              ) : (
                formatBytes(stats.files_total.size, 2, true)
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

DashboardStatsOverview.propTypes = {
  profile: PropTypes.object,
};

DashboardStatsOverview.defaultProps = {
  profile: null,
};

export default connect(mapStateToProps)(DashboardStatsOverview);
